import {get, post} from '../index'
export default {
  // 技师列表
  getPrettifyTechnicianList (querys) {
    return get('/beauty/AdminTechnician/list', querys)
  },
  // 获取员工列表
  getPrettifyStaffList (querys) {
    return get('/beauty/AdminTechnician/getStaffForSelect', querys)
  },
  // 技师添加
  addPrettifyTechnicianInfo (querys) {
    return post('/beauty/AdminTechnician/addOne', querys)
  },
  // 技师删除
  delPrettifyTechnicianInfo (querys) {
    return post('/beauty/AdminTechnician/delete', querys)
  },
  // 服务列表
  getPrettifyServiceList (querys) {
    return get('/beauty/AdminService/list', querys)
  },
  // 服务添加
  addPrettifyServiceInfo (querys) {
    return post('/beauty/AdminService/createOne', querys)
  },
  // 服务编辑
  editPrettifyServiceInfo (querys) {
    return post('/beauty/AdminService/updateOne', querys)
  },
  // 服务上下架、删除
  updatePrettifyServiceInfo (querys) {
    return post('/beauty/AdminService/updateStatus', querys)
  },
  // 服务详情
  getPrettifyServiceDetail (querys) {
    return get('/beauty/AdminService/getInfo', querys)
  },
  // 服务分类添加
  addPrettifyServiceClassifyInfo (querys) {
    return post('/beauty/AdminServiceType/createOne', querys)
  },
  // 服务分类修改
  editPrettifyServiceClassifyInfo (querys) {
    return post('/beauty/AdminServiceType/updateOne', querys)
  },
  // 服务分类列表
  getPrettifyServiceClassifyList (querys) {
    return get('/beauty/AdminServiceType/listWithChildren', querys)
  },
  // 服务分类删除
  delPrettifyServiceClassifyInfo (querys) {
    return post('/beauty/AdminServiceType/deleteAndChilren', querys)
  },
  // 服务分类详情
  getPrettifyServiceClassifyDetail (querys) {
    return get('/beauty/AdminServiceType/getOne', querys)
  },
  // 活动添加
  addPrettifyActivityInfo (querys) {
    return post('/beauty/AdminBeautyActivity/createOne', querys)
  },
  // 活动列表
  getPrettifyActivityList (querys) {
    return get('/beauty/AdminBeautyActivity/list', querys)
  },
  // 活动详情
  getPrettifyActivityDetail (querys) {
    return get('/beauty/AdminBeautyActivity/getOne', querys)
  },
  // 活动下拉所有项目
  getPrettifyAllProjectList () {
    return get('/beauty/AdminService/listAll')
  },
  // 活动编辑
  editPrettifyActivityInfo (querys) {
    return post('/beauty/AdminBeautyActivity/updateOne', querys)
  },
  // 活动上下架
  updatePrettifyActivityInfo (querys) {
    return post('/beauty/AdminBeautyActivity/udpateStatus', querys)
  },
  // 预约列表
  getPrettifySubscribeList (querys) {
    return get('/beauty/AdminServiceAppiont/list', querys)
  },
  // 预约配置添加、修改
  addOrEditPrettifySubscribelInfo (querys) {
    return post('/beauty/AdminServiceAppiontConfig/updateInfo', querys)
  },
  // 预约配置回显
  getPrettifySubscribelInfo (querys) {
    return get('/beauty/AdminServiceAppiontConfig/getInfo', querys)
  },
  // 获取部门配置
  getPrettifyCompanyOptions () {
    return get('/shop/AdminShopGoods/companyAndCate')
  },
  // 门店二维码添加
  addPrettifyStoreQRCode (querys) {
    return post('/beauty/AdminBeautyStoreQr/createOne', querys)
  },
  // 门店二维码列表
  getPrettifyQRCodeList (querys) {
    return get('/beauty/AdminBeautyStoreQr/list', querys)
  },
  // 门店二维码删除
  delPrettifyQRCodeInfo (querys) {
    return post('/beauty/AdminBeautyStoreQr/deleteOne', querys)
  },
  // 优惠券列表
  getPrettifyCouponList (querys) {
    return get('/beauty/AdminBeautyServiceCoupon/list', querys)
  },
  // 优惠券详情
  getPrettifyCouponInfo (querys) {
    return get('/beauty/AdminBeautyServiceCoupon/getOne', querys)
  },
  // 优惠券添加
  addPrettifyCouponInfo (querys) {
    return post('/beauty/AdminBeautyServiceCoupon/createOne', querys)
  },
  // 优惠券编辑
  editPrettifyCouponInfo (querys) {
    return post('/beauty/AdminBeautyServiceCoupon/updateOne', querys)
  },
  // 服务订单列表
  getPrettifyOrderList (querys) {
    return get('/beauty/AdminBeautyServiceOrder/list', querys)
  },
  // 订单完成提交
  handlePrettifyOrderSubmit (querys) {
    return post('/beauty/AdminBeautyServiceOrder/completeOrder', querys)
  },
  // 订单提成列表
  getPrettifyOrderRoyalty (querys) {
    return get('/beauty/AdminBeautyStaffCommission/list', querys)
  },
  // 佣金详情
  getPrettifyCommissionDetail (querys) {
    return get('/beauty/AdminBeautyStaffCommission/staffDetaillist', querys)
  },
  // 退款列表
  getPrettifyRefundList (querys) {
    return get('/beauty/AdminBeautyServiceOrderRefund/list', querys)
  },
  // 同意退款申请
  confirmPrettifyRefundInfo (querys) {
    return post('/beauty/AdminBeautyServiceOrderRefund/approveRefund', querys)
  },
  // 拒绝退款申请
  cancelPrettifyRefundInfo (querys) {
    return post('/beauty/AdminBeautyServiceOrderRefund/refuseRefund', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/prettify.js